<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Data Kategori</h2>

      <br />

      <div class="btn-bar">
        <router-link to="/master/kategori/-1" class="btn-fill btn-width-auto">
          Tambah Kategori
        </router-link>
        <div class="btn-grid">
          <form @submit.prevent="filterData" v-if="showFilter">
            <input
              type="search"
              placeholder="Cari..."
              v-model="keyword"
              ref="cari"
              @blur="showFilter = false"
            />
          </form>
          <button
            type="button"
            class="btn-outline"
            v-if="!showFilter"
            @click="exportExcel"
            :disabled="loadingExcel"
          >
            Export Excel
          </button>
          <button
            type="button"
            class="btn-outline btn-search"
            @click="toggleFilter"
          >
            <close v-if="showFilter" />
            <search v-if="!showFilter" />
          </button>
        </div>
      </div>

      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>Nama</th>
              <th>Tipe</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in data"
              :key="index"
              @click="$router.push('/master/kategori/' + item.id)"
            >
              <td>{{ item.nama }}</td>
              <td>{{ item.tipe }}</td>
              <td>
                <span @click.stop="confirmHapus(item)" class="btn-hapus"
                  >Hapus</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal" @click="closeModal" v-if="modalOpen">
      <div class="modal-body">
        <h3>Import Data</h3>
        <small>
          Silakan download file excel berikut ini untuk menyesuaikan format.
          <a href="http://">Download template excel</a>
        </small>

        <div>
          <div class="button-bar">
            <div>
              <input type="file" @change="readExcel" />
              <br />
              <small
                >Nama barang yang sama akan diupdate harga / satuannya</small
              >
            </div>
            <div>
              <button
                type="button"
                class="btn btn-fill"
                @click="prosesExcel"
                :disabled="loadingProses"
              >
                Proses File
              </button>
            </div>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama</th>
                <th>Harga</th>
                <th>Satuan</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in excelData"
                :key="index"
                :class="'flicker-' + index"
                class="flicker"
              >
                <td>{{ ++index }}</td>
                <td>{{ item.nama }} {{ item.processing }}</td>
                <td>{{ item.harga | number }}</td>
                <td>{{ item.satuan }}</td>
                <td align="right">
                  <span style="display: none">✓</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import readXlsxFile from "read-excel-file";

import * as api from "../../api/Api";
import Search from "./../icons/Search.vue";
import Close from "./../icons/Close.vue";

export default {
  name: "BahanBaku",
  components: {
    Search,
    Close,
  },
  data() {
    return {
      loading: false,
      loadingProses: false,
      loadingExcel: false,
      keyword: "",
      tmpData: [],
      data: [],
      excelData: [],
      showFilter: false,
      modalOpen: false,
    };
  },
  methods: {
    toggleFilter() {
      this.showFilter = !this.showFilter;
      if (this.showFilter) {
        setTimeout(() => {
          this.$refs["cari"].focus();
        }, 150);
      }
    },
    loadData() {
      this.loading = true;
      api
        .get("/v4/kategori?id_toko=" + this.$toko.id)
        .then((r) => {
          this.loading = false;
          this.data = r.data;
          this.tmpData = r.data;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    filterData() {
      if (this.keyword) {
        this.data = this.data.filter((k) => {
          return k.nama.toLowerCase().includes(this.keyword);
        });
      } else {
        return (this.data = this.tmpData);
      }
    },
    confirmHapus(item) {
      if (confirm("Hapus " + item.nama + "?")) {
        api.post("/v4/kategori/delete", item).then((r) => {
          this.$toast("Berhasil dihapus");
          this.loadData();
        });
      }
    },
    exportExcel() {
      if (this.data.length <= 0) {
        this.$toast("Tidak ada data untuk didownload");
        return;
      }

      this.loadingExcel = true;
      api
        .get("/v1/bahan-baku/export-excel?id_toko=" + this.$toko.id)
        .then((r) => {
          this.loadingExcel = false;
          if (r.valid) {
            location.href = r.filename;
          }
        })
        .catch((e) => {
          this.loadingExcel = false;
        });
    },
    readExcel(e) {
      readXlsxFile(e.target.files[0]).then((rows) => {
        rows.forEach((row, index) => {
          if (index > 0) {
            this.excelData.push({
              id_toko: this.$toko.id,
              nama: row[0],
              harga: row[1],
              satuan: row[2],
            });
          }
        });
      });
    },
    prosesExcel() {
      if (this.excelData.length <= 0) {
        this.$toast("Tidak ada data yang bisa diproses");
        return;
      }

      this.loadingProses = true;
      this.singleProsesExcel(0);
    },
    singleProsesExcel(index) {
      let data = this.excelData[index];

      if (index > 0) {
        document
          .querySelector(".flicker-" + (index - 1))
          .classList.remove("animate-flicker");
      }
      document
        .querySelector(".flicker-" + index)
        .classList.add("animate-flicker");

      api
        .post("/v1/bahan-baku/process-excel", data)
        .then((r) => {
          document
            .querySelector(".flicker-" + index)
            .querySelector("span").style.display = "block";

          setTimeout(() => {
            if (index < this.excelData.length - 1) {
              this.singleProsesExcel(index + 1);
            } else {
              alert("File selesai diproses");
              location.reload();
            }
          }, 150);
        })
        .catch((e) => {
          setTimeout(() => {
            if (index < this.excelData.length - 1) {
              this.singleProsesExcel(index + 1);
            } else {
              alert("File selesai diproses");
              location.reload();
            }
          }, 150);
        });
    },
    closeModal(e) {
      if (e.target.classList[0] == "modal") {
        this.modalOpen = false;
      }
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .filter {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 15px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
    input {
      width: 100%;
    }
  }

  .btn-grid {
    display: grid;
    grid-template-columns: 1fr 50px;
    grid-column-gap: 10px;
    form {
      width: 300px;
      input {
        width: 100%;
      }
    }
    .btn-search {
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .table-wrapper {
    margin-top: 15px;
    height: calc(100vh - 270px);
  }

  .modal {
    position: fixed;
    margin: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    .modal-body {
      background: #fff;
      width: 800px;
      height: 500px;
      padding: 20px;
      margin-top: 100px;
      border-radius: 7px;
      overflow: auto;
      h3 {
        margin: 0;
      }
      a {
        color: var(--primary);
        text-decoration: none;
        &:hover {
          font-weight: bold;
        }
      }
      input {
        width: auto;
      }
      .button-bar {
        display: flex;
        justify-content: space-between;
        margin: 15px 0 10px;
      }

      table {
        tr.animate-flicker {
          font-weight: bold;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/master/Kategori.vue